import { render } from "./ViewPageInfo.vue?vue&type=template&id=0bae3f1d&scoped=true"
import script from "./ViewPageInfo.vue?vue&type=script&lang=js"
export * from "./ViewPageInfo.vue?vue&type=script&lang=js"

import "./ViewPageInfo.vue?vue&type=style&index=0&id=0bae3f1d&scoped=true&lang=css"

import exportComponent from "/var/www/mkssg/mkssg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bae3f1d"]])

export default __exports__